var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwdLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 204,
    viewBox: "0 0 204 204",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.146 77.2697L116.606 66.8108V0H87.4635V66.8108L97.9241 77.2697C100.198 79.5433 103.907 79.5433 106.181 77.2697H106.146Z",
    fill: "#2BFF89"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.89 126.73L87.4294 137.189V204H116.572V137.189L106.112 126.73C103.838 124.457 100.129 124.457 97.8552 126.73H97.89Z",
    fill: "#2BFF89"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M204 87.4137H137.178L126.717 97.8725C124.443 100.146 124.443 103.854 126.717 106.128L137.178 116.587H204V87.4137Z",
    fill: "#2BFF89"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2829 97.8725L66.8221 87.4137H0V116.551H66.8221L77.2829 106.093C79.5569 103.819 79.5569 100.111 77.2829 97.8375V97.8725Z",
    fill: "#2BFF89"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.415 87.4136L137.178 87.4137L184.409 40.1913L163.803 19.5884L116.573 66.8106V81.572C116.573 84.7901 119.196 87.4136 122.415 87.4136Z",
    fill: "#2BFF89"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4341 81.607V66.8457L40.2038 19.6234L19.5973 40.2263L66.8276 87.4487H81.5916C84.8102 87.4487 87.4341 84.8252 87.4341 81.607Z",
    fill: "#2BFF89"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116.573 122.393V137.154L163.803 184.377L184.409 163.774L137.179 116.551H122.415C119.196 116.551 116.573 119.175 116.573 122.393Z",
    fill: "#2BFF89",
    fillOpacity: 0.15
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6257 116.551H66.8618L19.6315 163.774L40.2379 184.377L87.4682 137.154V122.393C87.4682 119.175 84.8444 116.551 81.6257 116.551Z",
    fill: "#2BFF89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwdLoading);
export default __webpack_public_path__ + "static/media/twd-loading.c2b78c144a510b3568c2cf904cf061f3.svg";
export { ForwardRef as ReactComponent };